import { Logo as LogoIcon } from 'components/Elements/Icons';

import Styles from './index.module.scss';

export const Logo = () => {
	return (
		<div className={Styles.header}>
			<div className={Styles.logo}>
				<LogoIcon />
			</div>
			<span className={Styles.text}>Turnpike</span>
		</div>
	);
};
